import { apiClient } from "../apiClient";

// Error handaling // Auth-2.3.1
class AuthError extends Error{
    constructor(message, code, originalError, fieldError=null){
        super(message);
        this.code = code;
        this.originalError = originalError;
        this.fieldError = fieldError
        this.timestamp = new Date().toISOString()
    }

}

// Auth-2.0
class AdminLoginService {
    // Auth-2.1 async call with email and pass paramenter
   async login (email, password){
        try {
            // Auth-2.2 post api with email and password 
            const respons =  await apiClient.post('/api/auth/admin/login',{
                    email:email.trim(),
                    password: password.trim()
            }, { withCredentials: true })
            // Log successful login for security audit
            // console.info(`Admin login successful: ${email}`);
            // call admin profile 
            // await adminAuth.loadAdmin();
            return respons.data
            
        } catch (error) {
            // Auth-2.3.2 error handling
            let errorMessage = "Login Failed";
            let errorCode = "UNKNOWN ERROR";
            let fieldError = null;

            
            if(error.response?.status === 401){
                errorMessage="Invalid credentials";
                errorCode= "INVALID_CREDENTIALS";
                fieldError = {field:'email', message :'Invalid email or password'}
                fieldError = {field:'password', message :'Invalid email or password'}

            }else if(error.respons?.status === 403){
                errorMessage="Access denied. Admin privileges required.";
                errorCode="Forbidden"
            }
            
            else if(error.response?.status === 429){
                errorMessage="Too many attempts. Please try again later.";
                errorCode="RATE_LIMITED"
            }else if(error.response?.data?.error){
                errorMessage=  error.response.data.error;
                errorCode = 'API_ERROR'
            }

            // Log security events
            console.warn(`Admin Login Failed ${email} - ${errorCode} - ${errorMessage}`)

            // send to monitor service
            this.reportToMonitoring({
                email,
                errorCode,
                timestamp: new Date().toISOString
            })

            throw new AuthError(errorMessage, errorCode, error, fieldError)
        }
    }
    reportToMonitoring(data) {
        // Integrate with your monitoring service (Sentry, LogRocket, etc.)
        if (window.analytics) {
            window.analytics.track('admin_login_failed', data);
        }
    }
}
// Auth-2.4 export service
export const adminLoginService = new AdminLoginService() 
// Auth-2.3.3 error handling
export { AuthError }